<template>
  <div class="sanitas-header-teaser">
    <div class="sanitas-header-teaser-title">
      <slot></slot>
    </div>
    <a
      v-if="url"
      :href="url"
      :target="target"
      class="sanitas-header-teaser-link"
    >
      {{ linkText }}
    </a>
  </div>
</template>

<script>
export default {
  name: 'SanitasHeaderTeaser',
  props: {
    linkText: {
      type: String,
      default: '',
    },
    url: {
      type: String,
      default: '',
    },
    target: {
      type: String,
      default: '',
    },
  },
}
</script>

<style scoped lang="postcss">
.sanitas-header-teaser {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  width: 100%;
  align-items: center;
  padding-top: 60px;

  &-title {
    flex-grow: 1;
    font-size: 35px;
    line-height: 50px;
    font-weight: 700;
    font-family: Faustina, serif;
    color: var(--c-primary-color-2);
    padding-right: 20px;
  }
  &-link {
    flex-shrink: 0;
    font-size: 15px;
    font-weight: bold;
    padding: 17px 34px;
    background-color: var(--c-primary-color-3);
    border-radius: 35px;
    color: var(--c-primary-neutral-3);
    min-width: 200px;
    min-height: 50px;
    text-align: center;
    transition: 0.25s;
    max-width: 100%;

    &:hover {
      background-color: var(--c-tint-color-1);
      border-bottom: none;
    }
  }
}
@media (max-width: 1200px) {
  .sanitas-header-teaser {
    padding-top: 40px;
  }
}
@media (max-width: 490px) {
  .sanitas-header-teaser {
    padding-top: 20px;
    padding-bottom: 20px;
    &-title {
      font-size: 20px;
      line-height: 30px;
      margin-bottom: 10px;
      text-align: center;
    }
    &-link {
      width: 100%;
    }
  }
}
</style>
